// AvantiSchool.js
import React from "react";
import "./AvantiSchool.css";
import prabhupada from "../assets/prabhupada.webp";
// import school from "../assets/school.webp";
import bcs from "../assets/bcsSwami.webp";
import schoolBg from "../assets/school.webp";

const features = [
  "Academic Excellence",
  "Value-Based Education",
  "Experienced Faculty",
  "Smart Classrooms",
  "Yoga & Meditation",
  "Sports & Activities",
];

const programs = ["Pre-Primary", "Primary", "Middle School", "Secondary"];

export default function AvantiSchool() {
  return (
    <div className="avanti">
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,.55),rgba(0,0,0,.55)), url(${schoolBg})`,
        }}
      >
        <div className="overlay">
          <div className="container">
            <span className="badge">
              Educational Initiative of ISKCON Ujjain
            </span>
            <h1>Avanti School of Excellence</h1>
            <p>
              Where tradition meets modern education — nurturing young minds
              through academic excellence, character development, and spiritual
              wisdom.
            </p>
            <div className="actions">
              {/* Apply for Admission */}
              <a
                href="https://www.avantischools.com/admission/"
                target="_blank"
                className="btn primary"
                style={{
                  backgroundColor: "#f57c00",
                  color: "#fff",
                  border: "none",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#ff9800";
                  e.target.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#f57c00";
                  e.target.style.boxShadow = "none";
                }}
              >
                Apply for Admission
              </a>

              {/* Know More */}
              <a
                href="https://www.avantischools.com/"
                target="_blank"
                className="btn secondary"
                style={{
                  border: "2px solid #fff",
                  color: "#fff",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#fff";
                  e.target.style.color = "#f57c00";
                  e.target.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#fff";
                  e.target.style.boxShadow = "none";
                }}
              >
                Know More
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      {/* <section id="about" className="container section two-col">
        <div>
          <h2>About Avanti School</h2>
          <p>
            Avanti School of Excellence is a flagship educational initiative of{" "}
            <b>ISKCON Ujjain</b>. The school strives to maximize every child's
            moral, spiritual, and academic potential in a welcoming, secure, and
            supportive environment rooted in Indian culture.
          </p>
          <p>
            We combine academic excellence with character development and
            spiritual values inspired by Srila Prabhupada and H.H. Bhakti Charu
            Swami Maharaj.
          </p>
        </div>
        <div className="image-placeholder">Campus Image</div>
      </section> */}

      {/* Vision Section */}
      <section className="section light">
        <div className="container center">
          <h2>Our Vision</h2>
          <blockquote>
            “To create an environment where children apply academic knowledge,
            critical thinking, and spiritual education to become responsible
            leaders of society.”
          </blockquote>
          <div className="grid">
            <div className="card">
              <h3>Academic Excellence</h3>
            </div>
            <div className="card">
              <h3>Character Development</h3>
            </div>
            <div className="card">
              <h3>Community Service</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="section saffron">
        <div className="container center">
          <h2>Programs Offered</h2>
          <div className="programs">
            {programs.map((p) => (
              <div key={p} className="program">
                {p}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facilities Section */}
      {/* <section className="section">
        <div className="container">
          <h2>Facilities</h2>
          <ul className="facility-list">
            {features.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        </div>
      </section> */}

      {/* Founders Section */}
      <section className="founders-section">
        <div className="section-title">
          <span>Our Inspiration</span>
          <h2>Founders & Visionaries</h2>
          <p>
            Guided by the teachings of Srila Prabhupada and H.H. Bhakti Charu
            Swami Maharaj.
          </p>
        </div>

        <div className="founder-card reverse">
          <div className="founder-image">
            <img src={prabhupada} alt="Srila Prabhupada" />
          </div>
          <div className="founder-content">
            <span className="small-line"></span>
            <h3>Srila Prabhupada</h3>
            <h5>Founder-Acharya of ISKCON</h5>
            <p>
              His Divine Grace A.C. Bhaktivedanta Swami Prabhupada was an Indian
              spiritual teacher and the founder-preceptor of the International
              Society for Krishna Consciousness, commonly known as “ISKCON” or
              the "Hare Krishna Movement“. At the age of 70 he went to America
              and started the Hare Krishna Movement. He established 108 ISKCON
              Temples . We are serving under his lotus feet.
            </p>
          </div>
        </div>
        <div className="founder-card">
          <div className="founder-image">
            <img src={bcs} alt="Bhakti Charu Swami" />
          </div>
          <div className="founder-content">
            <span className="small-line"></span>
            <h3>H.H. Bhakti Charu Swami Maharaj</h3>
            <h5>Spiritual Mentor</h5>
            <p>
              His Holiness Bhakti Charu Swami Maharaj was a disciple of His
              Divine Grace A.C. Bhaktivedanta Swami Srila Prabhupada. He was a
              Sannyasi and initiating spiritual master, a member of the GBC
              (Governing Body Commission ISKCON). He traveled and preached
              across India, the USA, the UK, Western Europe, South Africa,
              Australia, and all over the world for the past 42 years. He
              developed many ISKCON projects for the pleasure of his spiritual
              master Srila Prabhupada, especially ISKCON Ujjain. Avanti School
              of Excellence was one such project inspired by H.H Bhakti Charu
              Swami Maharaj, and all management and staff were happy to serve
              under his authority
            </p>
          </div>
        </div>
      </section>
      {/* Closing Section */}
      <section className="section closing">
        <div className="container center">
          <h2>Join Us at Avanti School</h2>
          <p>
            Avanti School of Excellence School’s vision is to create an
            environment where children apply academic knowledge, critical
            thinking and spiritual education to become ideal leaders of the
            society.
          </p>
          <a
            href="https://www.avantischools.com/"
            className="btn primary"
            style={{
              backgroundColor: "#f57c00",
              color: "#fff",
              border: "none",
              transition: "all 0.3s ease",
              marginTop: "20px",
              display: "inline-block",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#ff9800";
              e.target.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#f57c00";
              e.target.style.boxShadow = "none";
            }}
          >
            Visit Now
          </a>
        </div>
      </section>

      {/* Contact Section */}
    </div>
  );
}
